import { Text } from "@mantine/core"
import { AxiosError } from "axios"
import { ZodIssue } from "zod"

import { InlineBanner } from "~/components/InlineBanner"

type Props = {
  traceabilityErrors: AxiosError<ZodIssue | string> | null
}
export function TraceabilityErrors({ traceabilityErrors }: Props) {
  const errorMessage = traceabilityErrors?.response?.data
  return (
    <InlineBanner type="error" message={`${traceabilityErrors?.message}`}>
      <Text fw={700}>
        {errorMessage
          ? `${errorMessage}`
          : "An unexpected error occurred. Please try again."}
      </Text>
    </InlineBanner>
  )
}
